/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { PermissionAction } from './PermissionAction.js';
import {
    PermissionActionFromJSON,
    PermissionActionFromJSONTyped,
    PermissionActionToJSON,
} from './PermissionAction.js';
import type { PermissionResource } from './PermissionResource.js';
import {
    PermissionResourceFromJSON,
    PermissionResourceFromJSONTyped,
    PermissionResourceToJSON,
} from './PermissionResource.js';
import type { PermissionScope } from './PermissionScope.js';
import {
    PermissionScopeFromJSON,
    PermissionScopeFromJSONTyped,
    PermissionScopeToJSON,
} from './PermissionScope.js';

/**
 * 
 * @export
 * @interface UserPermission
 */
export interface UserPermission {
    /**
     * 
     * @type {PermissionResource}
     * @memberof UserPermission
     */
    resource?: PermissionResource;
    /**
     * 
     * @type {PermissionAction}
     * @memberof UserPermission
     */
    action?: PermissionAction;
    /**
     * 
     * @type {PermissionScope}
     * @memberof UserPermission
     */
    scope?: PermissionScope;
}

/**
 * Check if a given object implements the UserPermission interface.
 */
export function instanceOfUserPermission(value: object): boolean {
    return true;
}

export function UserPermissionFromJSON(json: any): UserPermission {
    return UserPermissionFromJSONTyped(json, false);
}

export function UserPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'resource': json['resource'] == null ? undefined : PermissionResourceFromJSON(json['resource']),
        'action': json['action'] == null ? undefined : PermissionActionFromJSON(json['action']),
        'scope': json['scope'] == null ? undefined : PermissionScopeFromJSON(json['scope']),
    };
}

export function UserPermissionToJSON(value?: UserPermission | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resource': PermissionResourceToJSON(value['resource']),
        'action': PermissionActionToJSON(value['action']),
        'scope': PermissionScopeToJSON(value['scope']),
    };
}

